import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../actions';
import { tap, mergeMap, map, catchError, switchMap } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { SearchService, TopicService } from 'app/services';

@Injectable()
export class CoveragesEffects {
  constructor(
    private actions$: Actions,
    private topicService: TopicService,
    private searchService: SearchService
  ) {}

  loadCoverages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.setCoverages),
      mergeMap(action =>
        this.getContents$(action).pipe(
          tap(response => console.log('loadCoverages$')),
          switchMap(response => [
            actions.setCoveragesSuccess({
              contents: { ...response }
            })
          ]),
          catchError(err => of(actions.setSearchError({ payload: err })))
        )
      )
    )
  );

  getContents$(action): Observable<any> {
    if (action.isSearch) {
      return this.searchService.search(
        action.searchBody,
        action.sort,
        'contents',
        action.page,
        action.size
      );
    } else {
      return this.topicService.feedTopic(
        action.topicId,
        action.sort,
        action.page,
        action.size
      );
    }
  }
}
